//
// Flight UI component for contest listing pagination.
//

import { component as defineComponent } from 'flightjs';

function contestListingPaginator() {
    this.attributes({
        link: 'a:not([data-button-disabled])'
    });

    this.loadPage = function(e, data) {
        e.preventDefault();
        this.trigger('uiBrowseFiltersUpdated', {'page': $(data.el).data('page')});
    };

    this.after('initialize', function() {
        this.on('click', {
            link: this.loadPage
        });
    });
}

export default defineComponent(contestListingPaginator);



// WEBPACK FOOTER //
// ./src/web/js/browse/ui/listings-pagination.js